module.exports = __webpack_public_path__ + "img/Trailer-icons.dff3288.svg";